/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */
import PropTypes from 'prop-types';
import { React, useEffect, useContext } from 'react';

import { DEPLOY_TYPE_GLOBAL } from '../../../utils/constants';
import CustomTextArea from '../../utils/CustomTextArea';
import StagedDeploymentConfig from './StagedDeploymentConfig';
import SelectedObjectsToDeployContext from '../../../config/SelectedAssetsContext';



export default function GlobalDeploy({
  setType, project, values, setValues, selectedExcludedValue, setSelectedExcludedValue,
  excludedValues, setExcludedValues, stagedDeployment, setStagedDeployment, onStagedConfigChange, onLoadingChange,
}) {
  const { selectedObjectsToDeploy } = useContext(SelectedObjectsToDeployContext);
  // DATA RETRIEVAL __________________________
  async function loadType() {
    setType(DEPLOY_TYPE_GLOBAL);
  }

  useEffect(() => {
    loadType();
  });

  const EXCLUDED_VALUES = ['NO-EXCLUDED', 'EXCLUDE-SERIAL', 'EXCLUDE-MARKET'];

  useEffect(() => {
    setExcludedValues('');
    setSelectedExcludedValue(EXCLUDED_VALUES[0]);
  }, []);

  const handleChange = (event) => {
    setExcludedValues('');
    setSelectedExcludedValue(event.target.value);
  };

  const handleTextAreaChange = (text) => {
    if (!text) {
      setExcludedValues('');
      return;
    }
    // Keep excludedValues as a string (comma-separated), don't convert to array
    const trimmedText = text.split(',').map((item) => item.trim()).join(',');
    setExcludedValues(trimmedText);
  };

  return (
    <div className="bg-gray-50">
      <div className="flex flex-col items-center">
        <div className="w-full">
          <div className="p-6 pb-4">
            <label className="text-gray-700 text-base leading-5">
              The deployment will be globally applied to all {project.name} machines.
            </label>
          </div>
        </div>
        
        <div className="w-full bg-white rounded-xl">
          <div className="p-6">
            <fieldset className="space-y-4">
              <legend className="text-sm font-medium text-gray-700 mb-4">Exclusion Options</legend>
              <div className="space-y-2">
                <div className="flex flex-wrap gap-6">
                  <label className="flex items-center">
                    <input
                      type="radio"
                      value={EXCLUDED_VALUES[0]}
                      checked={selectedExcludedValue === EXCLUDED_VALUES[0]}
                      onChange={handleChange}
                      className="mr-2"
                    />
                    No exclusions
                  </label>
                  <label className="flex items-center">
                    <input
                      type="radio"
                      value={EXCLUDED_VALUES[1]}
                      checked={selectedExcludedValue === EXCLUDED_VALUES[1]}
                      onChange={handleChange}
                      className="mr-2"
                    />
                    Exclude Serial Numbers
                  </label>
                  <label className="flex items-center">
                    <input
                      type="radio"
                      value={EXCLUDED_VALUES[2]}
                      checked={selectedExcludedValue === EXCLUDED_VALUES[2]}
                      onChange={handleChange}
                      className="mr-2"
                    />
                    Exclude Market Locations
                  </label>
                </div>
              </div>
            </fieldset>
          </div>

          {[EXCLUDED_VALUES[1], EXCLUDED_VALUES[2]].includes(selectedExcludedValue) && (
            <div className="px-6">
              <CustomTextArea
                screenId="inputExcludedGlobalDeployment"
                placeHolder="Excluded fields, separated by commas (option1, option2, ...)"
                size={300}
                values={excludedValues}
                setValues={handleTextAreaChange}
                isComment
              />
            </div>
          )}

          <div className="flex justify-end py-6 px-6">
            <label className="flex items-center">
              <input
                type="checkbox"
                checked={stagedDeployment}
                onChange={(e) => setStagedDeployment(e.target.checked)}
                className="mr-2"
              />
              Staged Deployment
            </label>
          </div>

          <StagedDeploymentConfig
            isEnabled={stagedDeployment}
            deploymentType={DEPLOY_TYPE_GLOBAL}
            selectedExcludedValue={selectedExcludedValue}
            excludedValues={excludedValues}
            selectedObjectsToDeploy={selectedObjectsToDeploy}
            onConfigChange={onStagedConfigChange}
            isBundleDeployment={selectedObjectsToDeploy?.[0]?.type === 'bundle'}
            onLoadingChange={onLoadingChange}
          />

          <div className="flex flex-col items-center pb-6">
            <div className="w-full">
              <CustomTextArea
                screenId="inputDeploymentComments-globalDeployment"
                title="Deployment description"
                placeHolder="Comments (optional)"
                size={300}
                values={values}
                setValues={setValues}
                isComment
                rows={4}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
GlobalDeploy.propTypes = {
  setType: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  project: PropTypes.object.isRequired,
  values: PropTypes.string.isRequired,
  setValues: PropTypes.func.isRequired,
  selectedExcludedValue: PropTypes.string.isRequired,
  setSelectedExcludedValue: PropTypes.func.isRequired,
  excludedValues: PropTypes.string.isRequired,
  setExcludedValues: PropTypes.func.isRequired,
  stagedDeployment: PropTypes.bool.isRequired,
  setStagedDeployment: PropTypes.func.isRequired,
  onStagedConfigChange: PropTypes.func,
  onLoadingChange: PropTypes.func,
};

GlobalDeploy.defaultProps = {
  onStagedConfigChange: () => {},
  onLoadingChange: () => {},
};
